import React, { useState, useRef, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
// import Button from "../../../components/Button";
import Image from 'next/image';
import CaseStudyForm from "./caseStudyForm";

export const CaseStudyPopup=(props)=> {
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(true);
  const [showCasestudyForm, setshowCasestudyForm] = useState(false);
  const showCSForm=()=>{
    setshowCasestudyForm(true);
    // setShowButton(false);

  }

  return (
    <Transition.Root show={props.show} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[110]"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed bg-[rgba(0,0,0,0.6)] inset-0 transition" />
        </Transition.Child>
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full w-full max-w-[800px]">
                <div className="bg-white p-6 pt-3 sm:px-3 sm:pb-4">
                <button className="absolute right-1 top-1 cursor-pointer focus:outline-none" onClick={props.onClose} ><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path fill="#000" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z"/></svg></button>
                  <div className="flex mt-1 mb-3 items-center sm:justify-center flex-wrap">
                    <div className="w-[65%] mt-1 mb-2 sm:hidden">
                        <h2 className="text-xxxl text-yellowcolor font-bold leading-8 sm:text-textxl">{props.heading}</h2>
                        <h3 className="text-lg font-bold text-secondary sm:text-base2 leading-[30px] mt-1">{props.subheading}</h3>
                    </div>
                    <div className="w-[35%] sm:w-full pl-5 mt-2 sm:text-center sm:pl-0">
                        <Image width={200} className="mx-auto block" src={props.formimage} alt={props.heading}/>
                    </div>
                    
                    <div className="w-full">
                    {!showCasestudyForm ? (
                        <>
                        <p className="text-lg text-secondary mb-2 sm:mt-2">{props.para}</p>
                        <button className=' bg-brand flex items-center text-white h-[55px] text-base px-4 rounded-xl' onClick={showCSForm}><span className='align-middle mr-[8px]'><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path fill='white' d="M16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16zm-3 10V8h-2v4H8l4 4 4-4h-3z"/></svg></span>Download Our Case Study</button>
                        </>
                    ) : (
                        <CaseStudyForm
                        formCSType={props.formCSType} formHeading= {props.heading}
                          />
                        )}
                    </div>
                  </div>
                </div>
                
              
                
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default CaseStudyPopup;
